<ion-content class="ion-content__subpage">
  @let availableAnnualFilters = availableAnnualFilters$ | async;
  @let isCrowdInvestorAccountActive = isCrowdInvestorAccountActive$ | async;
  @let hasPortfolioUpdatesFlag = hasPortfolioUpdatesFlag$ | async;
  <!-- Account switch -->
  @if (customer.app_location === 'ch') {
    <app-switch-account></app-switch-account>
  }
  @if (hasIssue) {
    <!-- No reporting -->
    @let endValues = endValues$ | async;

    @if (endValues && endValues.has_been_invested) {
      <div class="performance-wrapper performance-wrapper--error">
        <div class="performance-wrapper__title">
          {{ (currentAccount.kind === '3a' ? 'EVE2.reportingPause.title_3a' : 'SHARED.technicalIssues.heading') | translate }}
        </div>
        <p class="performance-wrapper__description">
          {{ (currentAccount.kind === '3a' ? 'EVE2.reportingPause.description_3a' : 'SHARED.technicalIssues.message') | translate }}
        </p>
      </div>
    }
  } @else if (isCrowdInvestorAccountActive === true) {
    <!-- CI active -->
    @let crowdInvestingValues = crowdInvestingValues$ | async;

    @if (crowdInvestingValues) {
      <div class="crowdinvesting-overview">
        <div class="main-title">{{ 'OVERVIEW.CI.title' | translate }}</div>
        <div class="shares-overview">
          <div>
            <div class="main-number">{{ crowdInvestingValues.number_of_shares }}</div>
            <div class="label">{{ 'insights.CI.stocks' | translate }}</div>
          </div>
          <div>
            <div class="other-number">{{ currentAccount.currency }} {{ crowdInvestingValues.total_stock_value | thousand }}</div>
            <div class="label">{{ 'insights.CI.totalValue' | translate }}</div>
          </div>
          <div>
            <div class="other-number">{{ currentAccount.currency }} {{ crowdInvestingValues.stock_value | thousand }}</div>
            <div class="label">{{ 'OVERVIEW.CI.singleValue' | translate }}</div>
          </div>
        </div>
      </div>
    }
  } @else {
    <!-- All other accounts -->
    @let endValues = endValues$ | async;

    @if (endValues) {
      @let amountToMinimumInvestment = calculateAmount(minimumInvestment, endValues?.deposits_value, endValues?.withdrawal_all);

      @if (!endValues.has_been_invested) {
        <!-- Not invested -->
        <app-home-mini-widget
          [percentage]="(endValues?.deposits_value - endValues?.withdrawal_all) / minimumInvestment"
          [currency]="currentAccount.currency"
          [amount]="amountToMinimumInvestment"
          [minInvestment]="minimumInvestment"
        ></app-home-mini-widget>
        <div class="mini-warning">
          <app-ds-rounded-icon
            size="large"
            [variant]="currentAccount?.has_low_investment_balance ? 'critical' : 'info'"
            [icon]="currentAccount?.has_low_investment_balance ? 'circle-x' : 'info'"
          ></app-ds-rounded-icon>

          @if (currentAccount?.has_low_investment_balance) {
            <!-- Only DE / AT accounts -->
            <h3 class="ds-heading-1">{{ 'SHARED.projectMini.callout.title' | translate }}</h3>
            <p class="ds-running-2 ds-color-core-neutral-8">
              {{
                'SHARED.projectMini.callout.description'
                  | translate
                    : {
                        amount: (amountToMinimumInvestment | thousand: currentAccount.currency)
                      }
              }}
            </p>
            <app-ds-button (clicked)="onInvestDetails()">{{ 'SHARED.projectMini.callout.link' | translate }}</app-ds-button>
          } @else {
            <!-- All accounts -->
            @if (currentAccount.kind !== '3a') {
              <h3 class="ds-heading-1">
                {{
                  (currentAccount.current_amount >= minimumInvestment
                    ? 'SHARED.projectMini.waitingForTradingDay.title'
                    : 'SHARED.projectMini.notInvested.title'
                  ) | translate
                }}
              </h3>
              <p
                class="ds-running-2 ds-color-core-neutral-8"
                [innerHTML]="
                  (currentAccount.current_amount >= minimumInvestment
                    ? 'SHARED.projectMini.waitingForTradingDay.description'
                    : 'SHARED.projectMini.notInvested.description'
                  )
                    | translate
                      : {
                          amount: (amountToMinimumInvestment | thousand: currentAccount.currency)
                        }
                "
              ></p>
            } @else {
              <!-- Only 3a-->
              <h3 class="ds-heading-1">
                {{
                  (currentAccount.current_amount >= minimumInvestment
                    ? 'SHARED.projectMini.waitingForLiberty.title'
                    : 'SHARED.projectMini.notInvested.title'
                  ) | translate
                }}
              </h3>
              <p class="ds-running-2 ds-color-core-neutral-8">
                {{
                  (currentAccount.current_amount >= minimumInvestment
                    ? 'SHARED.projectMini.waitingForLiberty.description'
                    : 'SHARED.projectMini.notInvested.description'
                  )
                    | translate
                      : {
                          amount: (amountToMinimumInvestment | thousand: currentAccount.currency)
                        }
                }}
              </p>
            }
            @if (currentAccount.current_amount < minimumInvestment) {
              <app-ds-button (clicked)="onInvestDetails()">
                {{ 'SHARED.projectMini.notInvested.buttonLabel' | translate }}
              </app-ds-button>
            }
          }
        </div>
      } @else {
        @let performanceData = performanceData$ | async;
        @let performance = performance$ | async;

        @if ((accountsMaxGraphDataLoaded$ | async) === false) {
          <div class="loading-placeholder">
            <ion-skeleton-text animated style="margin-left: auto; margin-bottom: var(--spacing-4); width: 148px; height: 16px"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 100%; height: 84px; margin-bottom: var(--spacing-8)"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 160px; height: 24px; margin-bottom: var(--spacing-4)"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 107px; height: 20px; margin-bottom: 0"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 163px; height: 36px; margin-bottom: var(--spacing-8)"></ion-skeleton-text>
          </div>
        } @else {
          <div class="updated-info-holder">
            <div class="updated-info" [ngClass]="{ active: infoList['updateDate'] }">
              <span class="ds-ui-3 ds-color-core-neutral-5">
                {{ 'PERFORMANCE.updateDate.label' | translate: { date: formatDate(endValues?.end_date, '.') } }}
              </span>
              <ion-icon (click)="showInfo('updateDate')" name="info2"></ion-icon>
            </div>
            @if (infoList['updateDate']) {
              <p class="ds-ui-3 ds-color-core-neutral-7" [innerHTML]="'PERFORMANCE.updateDate.info' | translate"></p>
            }
          </div>

          <app-track-deposit [currency]="currentAccount.currency" [kind]="currentAccount.kind"></app-track-deposit>

          @if (currentAccount.has_low_investment_balance) {
            <div class="mini-alert">
              <app-ds-callout
                variant="critical"
                [title]="'SHARED.projectMini.callout.title' | translate"
                [description]="
                  'SHARED.projectMini.callout.description'
                    | translate
                      : {
                          amount: (amountToMinimumInvestment | thousand: currentAccount.currency)
                        }
                "
              >
                <ng-container actions>
                  <app-ds-link routerLink="/tabs/account/invest-details" icon="arrow-down-to-line" variant="critical">
                    {{ 'SHARED.projectMini.callout.link' | translate }}
                  </app-ds-link>
                </ng-container>
              </app-ds-callout>
            </div>
          }
          <app-home-balance
            [totalAmount]="endValues?.end_value"
            [currency]="currentAccount.currency"
            [netInvestment]="endValues?.total_investment"
            [netReturn]="endValues?.profit_all"
          ></app-home-balance>

          <div class="balance-sheet-button">
            <span (click)="openBalanceSheet()">
              <ion-icon name="ds-balance-sheet"></ion-icon>
              <span class="ds-ui-2">{{ 'PERFORMANCE.accountOverview.reportingDetails.buttonLabel' | translate }}</span>
            </span>
          </div>

          @let marketUpdates = marketUpdates$ | async;

          @if (marketUpdates.loadState !== 'LOADED') {
            <div class="market-digest-loader">
              <div>
                <span><ion-skeleton-text animated style="width: 36px; height: 36px; margin: 0; border-radius: 50%"></ion-skeleton-text></span>
              </div>
              <div>
                <p class="ds-heading-2">
                  <ion-skeleton-text animated style="width: 136px; height: 20px; margin: 0 0 var(--spacing-1)"></ion-skeleton-text>
                </p>
                <p>
                  <ion-skeleton-text animated style="width: 240px; height: 16px; margin: 0 0 var(--spacing-1)"></ion-skeleton-text>
                </p>
                <p>
                  <ion-skeleton-text animated style="width: 240px; height: 16px; margin: 0 0 var(--spacing-2)"></ion-skeleton-text>
                </p>
                <p class="ds-heading-2"><ion-skeleton-text animated style="width: 180px; height: 18px; margin: 0"></ion-skeleton-text></p>
              </div>
            </div>
          } @else {
            @let marketUpdate = marketUpdates.marketUpdate;
            @if (marketUpdate !== null && !marketUpdate.dismissed) {
              <div class="market-digest-callout">
                <app-ds-callout
                  customIcon="newspaper"
                  variant="warning"
                  [title]="marketUpdate.title"
                  [description]="'PERFORMANCE.marketUpdates.description' | translate"
                >
                  <div class="market-digest-actions" actions>
                    <div>
                      <app-ds-link icon="arrow-right" (click)="onOpenLink($event, marketUpdate.id)">
                        {{ 'PERFORMANCE.marketUpdates.viewUpdate' | translate }}
                      </app-ds-link>
                    </div>
                    <div>
                      <app-ds-link icon="x" variant="neutral" (click)="onDismiss($event, marketUpdate.id)">
                        {{ 'PERFORMANCE.marketUpdates.dismiss' | translate }}
                      </app-ds-link>
                    </div>
                  </div>
                </app-ds-callout>
              </div>
            }
          }

          @if ((isAccountLoading$ | async)?.show === false) {
            <app-home-performance-chart
              [currency]="currentAccount.currency"
              [kind]="currentAccount.kind"
              [hasPortfolioUpdatesFlag]="hasPortfolioUpdatesFlag"
              [language]="customer.language"
              [chartData]="performanceData"
              [performance]="performance"
              [firstPerformanceDate]="endValues?.first_date"
              (filterChange)="onFilterChange($event, performance.range, performance.chartType)"
              (typeChange)="onTypeChange($event)"
              (openPerfSettings)="
                onOpenPerfSettings(
                  $event,
                  availableAnnualFilters,
                  performance?.range,
                  performance?.chartType,
                  performance?.showPortfolioChanges,
                  hasPortfolioUpdatesFlag
                )
              "
              (graphInteraction)="onGraphInteraction($event)"
            ></app-home-performance-chart>
          }

          <!-- Performance | Strategy | Activity | Risk -->
          <div class="perf-details-heading">
            <p class="ds-heading-1">{{ 'PERFORMANCE.contentSwitcher.heading' | translate }}</p>
            <app-ds-content-switcher
              type="medium"
              [activeTab]="activeTab"
              [tabs]="switcherTabs"
              (tabSwitched)="switchTabs($event)"
            ></app-ds-content-switcher>
          </div>

          <div class="content-wrapper">
            @if (activeTab === contentTabList.performance) {
              <!-- Current month data -->
              @let performanceSummary = performanceSummary$ | async;

              @if (performanceSummary) {
                <div class="performance-data">
                  <p class="ds-heading-2">{{ 'PERFORMANCE.contentSwitcher.performance.last30Days.title' | translate }}</p>
                  <div class="market-performance-data-list">
                    @if (performanceSummary.net_simple_return !== null) {
                      <app-market-performance-box
                        [net]="performanceSummary.net_simple_return"
                        [gross]="performanceSummary.gross_simple_return"
                        type="first"
                        info="PERFORMANCE.contentSwitcher.performance.last30Days.simpleReturn.info"
                      >
                        {{ 'PERFORMANCE.contentSwitcher.performance.last30Days.simpleReturn.name' | translate }}
                      </app-market-performance-box>
                    }

                    <app-market-performance-box
                      [type]="
                        performanceSummary.net_simple_return === null && performanceSummary.return_gross_benchmark !== null
                          ? 'first'
                          : performanceSummary.net_simple_return !== null && performanceSummary.return_gross_benchmark === null
                            ? 'last'
                            : performanceSummary.net_simple_return === null && performanceSummary.return_gross_benchmark === null
                              ? 'one-item'
                              : ''
                      "
                      [net]="performanceSummary.return_net.toFixed(2)"
                      [gross]="performanceSummary.return_gross.toFixed(2)"
                      info="PERFORMANCE.contentSwitcher.performance.last30Days.twr.info"
                    >
                      {{ 'PERFORMANCE.contentSwitcher.performance.last30Days.twr.name' | translate }}
                    </app-market-performance-box>

                    @if (performanceSummary.return_gross_benchmark !== null && currentAccount.kind !== '3a') {
                      <app-market-performance-box
                        [net]="performanceSummary.return_gross_benchmark"
                        [benchmarkDate]="formatDate(performanceSummary.end_period, '-')"
                        note="PERFORMANCE.contentSwitcher.performance.last30Days.marketGrossParformance.date"
                        info="PERFORMANCE.contentSwitcher.performance.last30Days.marketGrossParformance.info"
                        type="last"
                      >
                        {{ 'PERFORMANCE.contentSwitcher.performance.last30Days.marketGrossParformance.name' | translate }}
                      </app-market-performance-box>
                    }
                  </div>
                </div>
              }

              @let companiesStockPerformance = companiesStockPerformance$ | async;
              @let accountStocks = accountStocks$ | async;

              @if (!!companiesStockPerformance.length || !!accountStocks.length) {
                <div class="performance-companies">
                  <div class="performance-companies-header">
                    <p class="ds-heading-2">{{ 'PERFORMANCE.contentSwitcher.performance.last30DaysSingleStock.title' | translate }}</p>
                    <ion-icon name="info2" (click)="switchStockPerfInfo()"></ion-icon>
                  </div>
                  @if (showStockPerfInfo) {
                    <p class="ds-ui-3 ds-color-core-neutral-7">
                      {{ 'PERFORMANCE.contentSwitcher.performance.last30DaysSingleStock.info' | translate }}
                    </p>
                  }

                  @if (showEve2Callout$ | async) {
                    <app-ds-callout
                      variant="info"
                      [title]="'PERFORMANCE.contentSwitcher.strategy.migration.title' | translate"
                      [description]="'PERFORMANCE.contentSwitcher.strategy.migration.desc' | translate"
                    ></app-ds-callout>
                  } @else {
                    <div class="stock-performance-list">
                      <!-- Single stock performance -->
                      @if (!!companiesStockPerformance.length) {
                        <app-stock-performance-box
                          *ngFor="let item of companiesStockPerformance; let i = index"
                          [item]="item"
                          (dispatchCompanyDetail)="showCompanyDetail($event)"
                          [first]="i === 0"
                          [last]="i === companiesStockPerformance.length - 1"
                          [currency]="currentAccount.currency"
                        ></app-stock-performance-box>
                      } @else {
                        @for (stock of accountStocks; track stock; let first = $first; let last = $last) {
                          <app-stock-box
                            [stock]="stock"
                            [first]="first"
                            [last]="last"
                            [currency]="currentAccount.currency"
                            (viewCompanyDetail)="onViewCompanyDetail($event)"
                          ></app-stock-box>
                        }
                      }
                      <!-- End single stock perforamance -->
                    </div>
                  }
                </div>
              }

              <div class="disclaimer-note">
                <p class="ds-heading-3 ds-color-core-neutral-7" style="margin-bottom: var(--spacing-3)">
                  {{ 'PERFORMANCE.contentSwitcher.performance.disclaimer.title' | translate }}
                </p>
                <p class="ds-running-3 ds-color-core-neutral-7">
                  {{ 'PERFORMANCE.contentSwitcher.performance.disclaimer.' + (currentAccount.kind === '3a' ? '3a' : '3b') | translate }}
                </p>
              </div>
            }
            @if (activeTab === contentTabList.strategy) {
              <app-home-strategy
                [homeStrategyDetails]="homeStrategyDetails$ | async"
                [currency]="currentAccount.currency"
                [kind]="currentAccount.kind"
                [portfolioAllocation]="portfolioAllocation$ | async"
                [portfolioAllocationV2]="portfolioAllocationV2$ | async"
                [isEve2]="isEve2$ | async"
              ></app-home-strategy>
            }
          </div>
        }
      }
    }
  }
</ion-content>
